import { render, staticRenderFns } from "./CustomersOnline.vue?vue&type=template&id=1514ea5b&scoped=true&"
import script from "./CustomersOnline.vue?vue&type=script&lang=js&"
export * from "./CustomersOnline.vue?vue&type=script&lang=js&"
import style0 from "./CustomersOnline.vue?vue&type=style&index=0&id=1514ea5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1514ea5b",
  null
  
)

export default component.exports